
import en from './assets/locales/en/en.json';
import tr from './assets/locales/tr/tr.json';
import cn from './assets/locales/cn/cn.json';

export enum Language {
  EN = 'en',
  TR = 'tr',
  CN = 'cn'
};

export const LanguageList: any = [
  { name: 'English', value: Language.EN },
  { name: 'Türkçe (%5 Translated)', value: Language.TR },
  { name: '中文 (%5 Translated)', value: Language.CN },
];

export const LanguageResources = {
  en, cn, tr
};
